import React, { useState, useEffect, useRef } from 'react';
import banner1 from '../../../../../images/wl/19/etoLoginPageBanner_1.svg';
import banner2 from '../../../../../images/wl/19/etoLoginPageBanner_2.svg';
import banner3 from '../../../../../images/wl/19/etoLoginPageBanner_3.svg';
import banner4 from '../../../../../images/wl/19/etoLoginPageBanner_4.svg';
import banner5 from '../../../../../images/wl/19/etoLoginPageBanner_5.svg';
import banner6 from '../../../../../images/wl/19/etoLoginPageBanner_6.svg';
import getLocalizedText from 'helpers/getLocalizedText';

let persistedSlide = 0;
const slidesContent = [
    {
        title: 'auth.login.banner.acceptPayments.title',
        subtext: 'auth.login.banner.acceptPayments.subtext',
        bannerSrc: banner1
    },
    {
        title: 'auth.login.banner.invoicing.title',
        subtext: 'auth.login.banner.invoicing.subtext',
        bannerSrc: banner2
    },
    {
        title: 'auth.login.banner.customization.title',
        subtext: 'auth.login.banner.customization.subtext',
        bannerSrc: banner3
    },
    {
        title: 'auth.login.banner.antifraud.title',
        subtext: 'auth.login.banner.antifraud.subtext',
        bannerSrc: banner4
    },
    {
        title: 'auth.login.banner.fiscalization.title',
        subtext: 'auth.login.banner.fiscalization.subtext',
        bannerSrc: banner5
    },
    {
        title: 'auth.login.banner.massPayouts.title',
        subtext: 'auth.login.banner.massPayouts.subtext',
        bannerSrc: banner6
    }
];
export const PageAuthWrapperBannerWl19 = () => {
    const DELAY_BEFORE_NEXT_SLIDE = 7;
    const [currentSlide, setCurrentSlide] = useState(persistedSlide);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const startTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            setCurrentSlide((prev) => {
                const next = (prev + 1) % slidesContent.length;
                persistedSlide = next;
                return next;
            });
        }, DELAY_BEFORE_NEXT_SLIDE * 1000);
    };

    useEffect(() => {
        startTimer();
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [currentSlide]);

    const handleDotClick = (index: number) => {
        setCurrentSlide(index);
    };

    return (
        <div className='page-auth-banner-wl19'>
            <div className='page-auth-banner-wl19__slides'>
                {slidesContent.map(({ title, subtext, bannerSrc }, index) => (
                    <div
                        key={index}
                        className={`page-auth-banner-wl19__slide${index === currentSlide ? ' page-auth-banner-wl19__slide--active' : ''}`}
                    >
                        <img src={bannerSrc} className='page-auth-banner-wl19__image' />
                        <h4 className='page-auth-banner-wl19__title'>{getLocalizedText(title)}</h4>
                        <p className='page-auth-banner-wl19__subtext'>{getLocalizedText(subtext)}</p>
                    </div>
                ))}
            </div>
            <div className='page-auth-banner-wl19__dots'>
                {slidesContent.map((_, index) => (
                    <button
                        key={index}
                        className={`page-auth-banner-wl19__dot${index === currentSlide ? ' page-auth-banner-wl19__dot--active' : ''}`}
                        onClick={() => handleDotClick(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};